import { Autocomplete, TextField } from '@mui/material'
import { useLazySearchOrganizationsQuery } from './rtkOrganizationApi'
import { ItemOrganization } from '../item/model/ItemOrganization'
import { SyntheticEvent, useMemo, useState } from 'react'

export const OrganizationSelect = ({htmlId, value, onBlur, onChange, hasError = false, testId} : 
    {
        htmlId: string,
        value?: ItemOrganization,
        onBlur : () => void,
        onChange: (value: ItemOrganization | null) => void,
        hasError?: boolean, 
        testId? : string
    }) => {
    const [trigger, result] = useLazySearchOrganizationsQuery()
    const [organizationInput, setOrganizationInput] = useState('')

    const searchOrganization = (event: SyntheticEvent<Element, Event>, value: string) => {
        setOrganizationInput(value)
        if (value.length >= 3) {
            trigger({searchString: value})
        }
    }
    
    const organizations: ItemOrganization[] = useMemo(() => {
        if (!result.data) return []

        return result.data.map(org => {
            return {id: org?.id, label: org?.label, codificationSystem: org?.codificationSystem, code: org?.code}
        }).sort((a, b) => a.label.localeCompare(b.label))
    }, [result])

    return(
        <Autocomplete
            id={htmlId}
            data-cy="organization-identification-form"
            data-test={testId}
            value={value ?? null}
            options={organizations}
            classes={{paper: 'select-option'}}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            getOptionLabel={option => option.label}
            onBlur={onBlur}
            onChange={(_, value) => onChange(value)}
            onInputChange={searchOrganization}
            noOptionsText={organizationInput?.length >= 3 ? 'No options' : 'Please, input at least 3 characters'}
            renderOption={(props, option) =>
                <li {...props} key={option.id} data-cy={option.id}> {option.label}</li>}
            renderInput={(params) =>
                <TextField {...params}
                    data-testid="manufacturer"
                    required
                    data-cy="organization-identification-form-input"
                    placeholder="Select Organization"
                    error={hasError}
                />}
            />
    ) 
}